export const services = {
  // Airport Transfers
  airportTransfers: 'Traslados Aeropuerto',
  airportTransfersDesc: 'Servicio de transporte premium desde y hacia todos los aeropuertos de Marruecos y Canadá.',
  airportTransfersFeatures: [
    'Puntualidad garantizada',
    'Vehículos climatizados',
    'Conductores profesionales'
  ],
  airportTransfersDetailDesc: 'Nuestro servicio de traslado al aeropuerto le garantiza un viaje cómodo y sin estrés. Nuestros conductores profesionales le reciben con un cartel nominativo y se ocupan de su equipaje.',
  airportTransfersIncluded: [
    'Seguimiento de vuelo en tiempo real',
    'Vehículos Mercedes y BMW recientes',
    'Agua y refrescos a bordo',
    'WiFi gratuito en todos los vehículos',
    'Servicio de conserjería',
    'Asistencia 24h/24'
  ],
  airports: ['Mohammed V - Casablanca', 'Marrakech Menara', 'Agadir Al Massira', 'Fès Saïs', 'Montreal-Trudeau', 'Toronto Pearson'],
  
  // Tourist Circuits
  touristCircuits: 'Circuitos Turísticos',
  touristCircuitsDesc: 'Explore las maravillas de Marruecos con nuestros circuitos personalizados y guías expertos.',
  touristCircuitsFeatures: [
    'Itinerarios a medida',
    'Guías multilingües',
    'Descubrimientos auténticos'
  ],
  touristCircuitsDetailDesc: 'Descubra el Marruecos auténtico con nuestros circuitos a medida. Desde la medina de Fez hasta las dunas de Merzouga, cada itinerario está diseñado para ofrecerle una experiencia inolvidable.',
  touristCircuitsIncluded: [
    'Guía certificado multilingüe',
    'Vehículo 4x4 climatizado',
    'Alojamiento en riads y campamentos bereberes',
    'Comidas tradicionales incluidas',
    'Actividades culturales',
    'Fotos profesionales'
  ],
  destinations: ['Desierto de Merzouga', 'Valle del Dadès', 'Aït Benhaddou', 'Chefchaouen', 'Essaouira', 'Montañas del Atlas'],
  
  // Crew Transport
  crewTransport: 'Servicio de transporte para tripulaciones aéreas',
  crewTransportDesc: 'Servicio especializado para tripulaciones de cabina (cabin crew) y personal de vuelo.',
  crewTransportFeatures: [
    'Transporte cabin crew',
    'Horarios flexibles',
    'Servicio profesional'
  ],
  crewTransportDetailDesc: 'Nuestro servicio especializado está dirigido a tripulaciones de cabina (cabin crew) y personal de vuelo. Comprendemos las restricciones horarias y las necesidades específicas del sector aéreo.',
  crewTransportIncluded: [
    'Transporte adaptado a horarios de vuelo',
    'Vehículos cómodos para el descanso',
    'Servicio 24h/24 para todos los horarios',
    'Conductores formados en necesidades cabin crew',
    'Seguimiento de horarios de vuelo en tiempo real',
    'Tarifas preferenciales para aerolíneas'
  ],
  occasions: ['Tripulaciones en escala', 'Personal de vuelo', 'Cabin crew en descanso', 'Traslados hotel-aeropuerto', 'Servicios aerolíneas'],
  
  // Day Excursions
  dayExcursions: 'Excursiones de Un Día',
  dayExcursionsDesc: 'Descubra los sitios emblemáticos durante excursiones de un día inolvidables.',
  dayExcursionsFeatures: [
    'Salida matinal',
    'Sitios imprescindibles',
    'Regreso cómodo'
  ],
  dayExcursionsDetailDesc: 'Perfecto para descubrir los tesoros de Marruecos en un día. Nuestras excursiones combinan sitios históricos, paisajes naturales y experiencias culturales auténticas.',
  dayExcursionsIncluded: [
    'Transporte ida y vuelta',
    'Guía local experimentado',
    'Almuerzo tradicional',
    'Entradas a sitios turísticos',
    'Pausa té de menta',
    'Tiempo libre para compras'
  ],
  dayDestinations: ['Cascadas de Ouzoud', 'Valle de Ourika', 'Essaouira', 'Aït Benhaddou', 'Imlil', 'Ouarzazate'],
  
  // Chauffeur Service
  chauffeurService: 'Alquiler con Conductor',
  chauffeurServiceDesc: 'Vehículos premium con conductores experimentados para sus desplazamientos libres.',
  chauffeurServiceFeatures: [
    'Flexibilidad total',
    'Tarifas transparentes',
    'Disponibilidad 24h/7d'
  ],
  chauffeurServiceDetailDesc: 'Alquile un vehículo con conductor para total libertad en sus desplazamientos. Ideal para estancias prolongadas o viajes de negocios.',
  chauffeurServiceIncluded: [
    'Vehículo reciente y mantenido',
    'Conductor profesional bilingüe',
    'Combustible incluido',
    'Seguro a todo riesgo',
    'Asistencia en carretera 24h/24',
    'Limpieza diaria del vehículo'
  ],
  vehicles: ['Berlinas confort', 'SUV 7 plazas', 'Minibús 15 plazas', 'Vehículos de lujo'],
  
  // Canada Services
  canadaServices: 'Servicios Canadá',
  canadaServicesDesc: 'Extensión de nuestros servicios premium en Canadá para sus viajes norteamericanos.',
  canadaServicesFeatures: [
    'Montreal y Toronto',
    'Circuitos invernales',
    'Experiencia canadiense'
  ],
  canadaServicesDetailDesc: 'Descubra Canadá con el mismo nivel de servicio premium. Nuestros socios locales le ofrecen una experiencia auténtica en las ciudades canadienses más hermosas.',
  canadaServicesIncluded: [
    'Vehículos adaptados al clima canadiense',
    'Guías francófonos nativos',
    'Circuitos urbanos y naturaleza',
    'Experiencias invernales únicas',
    'Alojamiento en hoteles boutique',
    'Especialidades culinarias locales'
  ],
  cities: ['Montreal', 'Toronto', 'Quebec', 'Ottawa', 'Cataratas del Niágara', 'Mont-Tremblant']
};